import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
var __jsx = React.createElement;
import React from "react";
import MuiDrawer from "@mui/material/Drawer";
import { EngVillageThemeProvider } from "public/static/styles/theme/EngVillage/EngVillageThemeProvider";

/**
 * The EngVillageThemeProvider needs to be contained within the MuiDrawer since the content of the drawer
 * is created in a div that is outside of the main page that it is called from so the main page's theme is
 * out of scope.
 */

export var ELSDrawer = function ELSDrawer(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MuiDrawer, _extends({
    className: "es-drawer ".concat(className || "")
  }, props), /*#__PURE__*/React.createElement(EngVillageThemeProvider, null, props.children));
};
ELSDrawer.defaultProps = {
  anchor: "right"
};